import { makeStyles, Typography, Dialog, Tooltip, TooltipProps } from '@material-ui/core';
import React from 'react';
import { FontAwesomeSpriteIcon } from '../../shared/components/FontAwesomeLocal';
import styled from 'styled-components';
import { BlockType } from '../../../config/api/models/Block';

export const useStyles = makeStyles({
  hideBorder: {
    '&.MuiAccordion-root:before': {
      display: 'none',
    },
  },
  studentsList: {
    '&.MuiAccordionDetails-root': {
      flexDirection: 'column',
    },
  },
  tooltip: {
    backgroundColor: 'black',
  },
  tooltipArrow: {
    color: 'black !important',
  },
});

export const NotesIndicatorWrapper = styled(
  ({
    blockType,
    feedbackEnabled,
    bookmarkEnabled,
    hasBookMark,
    adjustIndicatorPosition,
    ...restProps
  }) => {
    return <div {...restProps} />;
  }
)`
  position: relative;
  z-index: 999;
`;

export const StyledNotesIndicator = styled(
  ({ isMobile, feedbackEnabled, bookMarkEnabled, blockType, ...restProps }) => (
    <div {...restProps} />
  )
)`
  display: flex;
  justify-content: center;
  position: absolute;
  top: ${({ blockType }) =>
    blockType === BlockType.VIDEO || blockType === BlockType.IFRAME ? '6.75rem' : '4.75rem'};
  right: ${({ feedbackEnabled, isMobile }) =>
    isMobile ? 'auto' : feedbackEnabled ? '-4.5rem' : '-4.5rem'};
  left: ${({ feedbackEnabled, isMobile }) =>
    isMobile ? (feedbackEnabled ? '-5.5rem' : '-2rem') : 'auto'};
  width: 4rem;
  height: 4rem;

  &.active {
    top: ${({ blockType }) =>
      blockType === BlockType.VIDEO || blockType === BlockType.IFRAME ? '6.25rem' : '4.5rem'};
  }
`;

export const DemoNotesIndicatorWrapper = styled(({ blockType, hasFeedback, ...restProps }) => (
  <div {...restProps} />
))``;

export const NoteWrapper = styled.div<{ editingNote?: string | undefined }>`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: 2rem;
  min-height: ${({ editingNote }) => (!editingNote?.length ? '200px' : '85vh')};
  background: white;
  padding: 1rem;
  margin-top: 4rem;
`;

export const StyledSpriteIcon = styled(({ title, disableTooltip, ...restProps }) => (
  <Tooltip
    disableHoverListener={disableTooltip === true}
    arrow
    placement="bottom-start"
    title={title}
  >
    <div>
      <FontAwesomeSpriteIcon {...restProps} />
    </div>
  </Tooltip>
))`
  min-width: 10%;
  color: #6c6453;
  margin-right: 1rem;
  &:hover {
    color: #0092bc;
  }
`;

export const StudentRow = styled.button<{isClickable: boolean;}>`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: none;
  background-color: transparent;
  border-bottom: 1px solid #c0c0c0;
  min-width: 100%;
  outline: none;
  cursor: ${props => props.isClickable ? 'pointer' : 'not-allowed'};
  margin: 0;
`;

export const StudentRowControls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const StyledGroupLabel = styled(Typography)`
  font-weight: bold;
  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const StyledDialog = styled(Dialog)`
  min-width: 358px;
  min-height: 195px;
`;

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(
  ({ theme }) =>
    `
  .MuiTooltip-tooltipArrow: {
    background-color: ${theme.palette.offblack} !important;
  }
  `
);
